/* Veithdia v1.7 · menú que se abre al pasar el cursor (15-10-2026)
   - En computador (con mouse), "Lentes de sol", "Guías" y "Ayuda" se despliegan al pasar
     el cursor y se cierran al salir, con una pequeña pausa para que no parpadeen.
   - Pasar de un menú a otro cambia el panel al instante.
   - Un clic con el mouse sobre un menú ya abierto no lo cierra.
   - El teclado (Tab, Enter, Esc) y el menú del celular siguen funcionando igual que antes. */
(function () {
  var OPEN_DELAY = 120; // ms antes de abrir: evita aperturas al cruzar el menú de pasada
  var CLOSE_DELAY = 280; // ms antes de cerrar: deja tiempo para bajar hasta el panel
  var PLAIN_DELAY = 120; // ms antes de cerrar al pasar a "Mujer", "Hombre" o "Nosotros"
  var DESKTOP = window.matchMedia('(min-width: 990px)');

  function init() {
    var nav = document.querySelector('.header__inline-menu');
    if (!nav || nav.dataset.vtHover === '1') return;
    nav.dataset.vtHover = '1';
    document.documentElement.classList.add('vt-hover-menu');

    var menus = Array.prototype.slice.call(nav.querySelectorAll('header-menu')).filter(function (m) {
      return m.querySelector('details > summary');
    });
    if (!menus.length) return;

    var openTimer = null;
    var closeTimer = null;

    function detailsOf(m) {
      return m.querySelector('details');
    }
    function isOpen(m) {
      return detailsOf(m).hasAttribute('open');
    }
    function anyOpen() {
      return menus.some(isOpen);
    }
    function clearTimers() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      openTimer = closeTimer = null;
    }
    function focusVisible(el) {
      try {
        return el.matches(':focus-visible');
      } catch (_) {
        return false;
      }
    }
    function isMouse(e) {
      return e.pointerType === 'mouse' && DESKTOP.matches;
    }

    // Puente invisible entre el título y el panel para que no se cierre al bajar el cursor.
    function setBridge(m) {
      var d = detailsOf(m);
      var s = d.querySelector('summary');
      var c = s.nextElementSibling;
      if (!c) return;
      var gap = Math.round(c.getBoundingClientRect().top - s.getBoundingClientRect().bottom);
      d.style.setProperty('--vt-menu-bridge', Math.max(0, Math.min(gap, 80)) + 'px');
    }

    function open(m) {
      menus.forEach(function (o) {
        if (o !== m) close(o);
      });
      var d = detailsOf(m);
      if (!d.hasAttribute('open')) d.setAttribute('open', '');
      d.querySelector('summary').setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () {
        setBridge(m);
      });
    }

    function close(m) {
      var d = detailsOf(m);
      if (!d.hasAttribute('open')) return;
      if (typeof m.close === 'function') {
        m.close();
      } else {
        d.removeAttribute('open');
        d.querySelector('summary').setAttribute('aria-expanded', 'false');
      }
    }

    function closeAll() {
      menus.forEach(close);
    }

    menus.forEach(function (m) {
      var d = detailsOf(m);
      var s = d.querySelector('summary');
      var lastPointer = '';

      m.addEventListener('pointerenter', function (e) {
        if (!isMouse(e)) return;
        clearTimers();
        if (isOpen(m)) return;
        if (anyOpen()) {
          open(m); // ya había otro abierto: cambia al instante
        } else {
          openTimer = setTimeout(function () {
            open(m);
          }, OPEN_DELAY);
        }
      });

      m.addEventListener('pointerleave', function (e) {
        if (!isMouse(e)) return;
        clearTimeout(openTimer);
        openTimer = null;
        if (!isOpen(m)) return;
        // No cerrar si alguien navega con el teclado dentro del panel.
        var a = document.activeElement;
        if (a && a !== s && d.contains(a) && focusVisible(a)) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          close(m);
        }, CLOSE_DELAY);
      });

      s.addEventListener('pointerdown', function (e) {
        lastPointer = e.pointerType;
      });

      s.addEventListener('click', function (e) {
        var mouseClick = lastPointer === 'mouse' && e.detail > 0 && DESKTOP.matches;
        lastPointer = '';
        if (!mouseClick) return; // teclado o pantalla táctil: comportamiento normal
        clearTimers();
        if (d.hasAttribute('open')) {
          // Ya está abierto por el cursor: el clic no lo cierra.
          e.preventDefault();
          setTimeout(function () {
            s.setAttribute('aria-expanded', 'true');
          }, 0);
        }
      });
    });

    // "Mujer", "Hombre", "Nosotros" (sin submenú): cierran el panel abierto.
    Array.prototype.forEach.call(nav.querySelectorAll('.list-menu--inline > li'), function (li) {
      if (li.querySelector('header-menu')) return;
      li.addEventListener('pointerenter', function (e) {
        if (!isMouse(e) || !anyOpen()) return;
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        closeTimer = setTimeout(closeAll, PLAIN_DELAY);
      });
    });

    // Esc cierra el panel abierto con el cursor (si el foco está dentro, lo maneja el tema).
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      menus.forEach(function (m) {
        if (isOpen(m) && !detailsOf(m).contains(document.activeElement)) {
          clearTimers();
          close(m);
        }
      });
    });

    // Al pasar a celular/tablet, se cierra lo que haya quedado abierto.
    var onChange = function () {
      if (!DESKTOP.matches) {
        clearTimers();
        closeAll();
      }
    };
    if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', onChange);
    else if (DESKTOP.addListener) DESKTOP.addListener(onChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Editor de temas: si se recarga el encabezado, se vuelve a activar.
  document.addEventListener('shopify:section:load', init);
})();
